import React from 'react';
import { Box, TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatPositiveAmount } from 'src/utils/formatAmout';
import OverflowTipography from 'src/components/OverflowTipography';

const BillingRow = ({
  period,
  client,
  clientId,
  equipment,
  equipmentId,
  initialPayment,
  rent,
  contribution,
  monthlyPrincipal,
  contractId
}) => {
  return (
    <TableRow hover>
      <TableCell align="center" sx={{ px: 1.5 }}>
        <Link to={`/contracts/${contractId}`}>{contractId}</Link>
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <OverflowTipography maxWidth="150px" title={client}>
            <Link to={`/clients/detail/${clientId}`}>{client}</Link>
          </OverflowTipography>
        </Box>
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        {period}
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <OverflowTipography maxWidth="150px" title={equipment}>
            <Link to={`/inventory/${equipmentId}`}>{equipment}</Link>
          </OverflowTipography>
        </Box>
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        {formatPositiveAmount(initialPayment)}
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        {formatPositiveAmount(rent)}
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        {formatPositiveAmount(contribution)}
      </TableCell>
      <TableCell align="center" sx={{ px: 1.5 }}>
        {formatPositiveAmount(monthlyPrincipal)}
      </TableCell>
    </TableRow>
  );
};

BillingRow.propTypes = {
  period: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  equipment: PropTypes.string.isRequired,
  equipmentId: PropTypes.string.isRequired,
  initialPayment: PropTypes.number.isRequired,
  rent: PropTypes.number.isRequired,
  contribution: PropTypes.number.isRequired,
  monthlyPrincipal: PropTypes.number.isRequired,
  contractId: PropTypes.string.isRequired
};

export default BillingRow;
